export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_03-567f01066af584e3fc55c2ed39532189.png";